import React, { useState } from 'react';
import { Play, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { galleryImages, galleryVideos } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openImage = (index) => setSelectedImage(index);
  const closeImage = () => setSelectedImage(null);
  const nextImage = () => setSelectedImage((prev) => (prev + 1) % galleryImages.length);
  const prevImage = () => setSelectedImage((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  const openVideo = (video) => setSelectedVideo(video);
  const closeVideo = () => setSelectedVideo(null);

  return (
    <section id="gallery" className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-amber-500 font-semibold text-sm tracking-wider uppercase">Galeria</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-2 mb-4">
            Veja nossas <span className="text-amber-500">Rotativas</span> em Ação
          </h2>
          <p className="text-stone-400 max-w-2xl mx-auto">
            Confira fotos e vídeos das nossas churrasqueiras rotativas. Qualidade que você pode ver!
          </p>
        </div>

        {/* Videos Section */}
        <div className="mb-12">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <Play className="w-5 h-5 text-amber-500" />
            Vídeos
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {galleryVideos.map((video, index) => (
              <div
                key={index}
                onClick={() => openVideo(video)}
                className="relative aspect-video bg-stone-800 rounded-xl overflow-hidden cursor-pointer group"
              >
                <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-stone-900 ml-1" fill="currentColor" />
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-white font-medium text-sm">{video.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Photos Grid */}
        <div>
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Fotos
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {galleryImages.slice(1).map((image, index) => (
              <div key={index} onClick={() => openImage(index + 1)} className="relative aspect-square bg-stone-800 rounded-xl overflow-hidden cursor-pointer group">
                <img src={image} alt={`Rotativa Gaúcha ${index + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
              </div>
            ))}
          </div>
        </div>

        {/* Image Modal */}
        {selectedImage !== null && (
          <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
            <button onClick={closeImage} className="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors"><X className="w-8 h-8" /></button>
            <button onClick={prevImage} className="absolute left-4 text-white hover:text-amber-500 transition-colors"><ChevronLeft className="w-10 h-10" /></button>
            <button onClick={nextImage} className="absolute right-4 text-white hover:text-amber-500 transition-colors"><ChevronRight className="w-10 h-10" /></button>
            <img src={galleryImages[selectedImage]} alt="Rotativa Gaúcha" className="max-w-full max-h-[85vh] object-contain rounded-lg" />
          </div>
        )}

        {/* Video Modal */}
        {selectedVideo && (
          <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
            <button onClick={closeVideo} className="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors z-10"><X className="w-8 h-8" /></button>
            <div className="w-full max-w-4xl">
              <video src={selectedVideo.url} className="w-full rounded-lg" controls autoPlay playsInline />
              <p className="text-white text-center mt-4 font-medium">{selectedVideo.title}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default GallerySection;
